module.exports = __webpack_public_path__ + "fd01afc831f550b3a2bf48f725441bb9.woff2";